import { XHR } from "./xhr"

export const fetches = (controller) => {
  XHR(controller)
  Object.assign(controller, {
    async fetchPartial(resource, options = {}) {
      options = {
        method: "GET",
        ...options,
        headers: {
          Accept: "text/html",
          "X-Turbo-Frame": "no-layout",
          ...(options.headers || {}),
        },
      }

      return this.fetch(resource, options)
    },

    async fetchPartialPost(resource, jsonBody, options = {}) {
      options = {
        method: "POST",
        body: JSON.stringify(jsonBody),
        ...options,
        headers: {
          Accept: "text/html",
          "X-Turbo-Frame": "no-layout",
          "Content-Type": "application/json",
          ...(options.headers || {}),
        },
      }

      return this.fetch(resource, options)
    },

    async fetchJson(resource, options = {}) {
      options = {
        method: "GET",
        ...options,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(options.headers || {}),
        },
      }

      return this.fetch(resource, options)
    },
  })
}
